import React from 'react';
import { Container, Paper, Stack, Text, Group, Badge } from '@mantine/core';
import { IconBuilding } from '@tabler/icons-react';
import { BuildingManagement } from '../../features/coordinator/buildings/BuildingManagement';

/**
 * Coordinator Room Management Page
 * 
 * Provides access to building/floor/room management for coordinators
 * Includes the existing BuildingManagement component
 */
const CoordinatorRoomManagement: React.FC = () => {
  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        {/* Header */}
        <Paper p="md" radius="md" withBorder>
          <Group justify="space-between">
            <Group gap="sm">
              <IconBuilding size={24} />
              <Text fw={700} size="xl">Room Management</Text>
            </Group>
            <Badge size="lg" variant="light" color="green">
              Full Management Access
            </Badge>
          </Group>
        </Paper>

        {/* Room Management Interface */}
        <BuildingManagement />
      </Stack>
    </Container>
  );
};

export default CoordinatorRoomManagement;
